import './LineLoader.scss';

export const LineLoader = () => {
    return (
        <div className='line-loader__container'>
            <span className='line-loader' />
        </div>
    );
};
